if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.inputQuantity = this.closest('.product__info-wrapper').querySelector('[name=quantity]');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cartUpSell = document.querySelector('free-shipping');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.inputQuantity) {
          this.inputQuantity.reportValidity();
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && !this.cartUpSell) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
        } else if (this.cartUpSell) {
          formData.append(
            'sections',
            this.cartUpSell.getSectionsToRender().map((section) => section.id)
          );
        }
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // Bugfix for mismatched shopify key IDs
            // We'll manually pass the added data to the notification component
            const cartNotification = document.querySelector('cart-notification');
            if (cartNotification) cartNotification.responseData = response;
            if (response.status) {
              if (response.description.includes('sold out')) {
                this.checkItemOnCart(response.description);
                return;
              }

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              quickAddModal.hide(true);
            }
            if (this.cartUpSell) {
              this.cartUpSell.renderContents(response);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      checkItemOnCart(originalErrorMessage = false) {
        fetch('/cart.js', {method: 'GET', headers: {'Content-Type': 'application/json'}})
          .then((response) => response.json())
          .then((response) => {
            let addToCartForm = document.querySelector('.add-to-cart__wrapper');

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              addToCartForm = quickAddModal.querySelector('.add-to-cart__wrapper');
            }

            let addQty = addToCartForm.querySelector('.quantity__input')
              ? addToCartForm.querySelector('.quantity__input').value
              : 1;
            let addId = addToCartForm.querySelector('[name="id"]').value;
            let itemMax = addToCartForm.querySelector('form').getAttribute('data-variant-max');

            let cartItems = response.items;
            let errorMessage = originalErrorMessage;
            for (var i = 0; i < cartItems.length; i++) {
              var itemId = cartItems[i].variant_id;
              var itemQty = cartItems[i].quantity;
              var totalItemQty = itemQty + addQty;
              if (itemId == addId) {
                if (totalItemQty > itemMax) {
                  errorMessage = 'All ' + itemMax + ' ' + cartItems[i].title + ' are in your cart.';
                }
              }
            }
            this.handleErrorMessage(errorMessage);
          });
      }
    }
  );
}
